export default __webpack_public_path__ + "static/media/hht2_ani_05.9507f20d.png";